import { useContext, useEffect, useState } from "react";
import { AscPlatformLayoutProps } from "../AscPlatformLayout.types";
import { AscPlatformLayoutContext } from "./AscPlatformLayoutContext";
import { v4 as uuidv4 } from "uuid";
/**
 * Component for setting props of AscPlatformLayout component from anywhere in the app.
 * It acts like a portal to the AscPlatformLayout using the context API.
 * It will take a snapshot of the initial props and restore them when the component is unmounted.
 * This is useful when for example in the auth flow we want to hide the sidebar and navigation but show them again when the user is logged in.
 */
export function AscPlatformLayoutPortal(
  props: Partial<AscPlatformLayoutProps>
) {
  const [key, setKey] = useState<string>("");
  const { pushProps, popProps } = useContext(AscPlatformLayoutContext);

  useEffect(() => {
    setKey(uuidv4());
  }, []);

  useEffect(() => {
    if (!props || !key) {
      return;
    }
    pushProps?.(key, props);

    return () => {
      popProps?.(key);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, key]);

  return null;
}
